import { createFileRoute } from "@tanstack/react-router";

import { BentoCard } from "@/components/ui/BentoCard";
import { SupportForm } from "@/components/support/SupportForm";

export const Route = createFileRoute("/_authenticated/support")({
  component: SupportRoute,
});

function SupportRoute() {
  return (
    <div className="flex justify-center p-6 lg:p-8">
      <BentoCard className="w-full max-w-2xl p-8">
        <h1 className="mb-6 font-heading text-3xl font-bold text-black dark:text-white">Support</h1>
        <SupportForm />
      </BentoCard>
    </div>
  );
}
